import { registerLocaleData } from '@angular/common';
import localeJa from '@angular/common/locales/ja';
import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';
import { DbsSpinnerService } from '@core/services/common';
import { SaucerLogService } from './core/services/apis';

@Component({
  selector: 'dbs-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent {
  constructor(
    private dbsSpinnerService: DbsSpinnerService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private saucerLogService: SaucerLogService,
  ) {
    this.saucerLogService.init();
    pdfDefaultOptions.assetsFolder = 'assets/pdf-viewer';

    this.dbsSpinnerService.trackRouteLoadIndicator();

    // CUSTOM_ICON
    this.matIconRegistry.addSvgIconResolver(
      (name, namespace) => {
        const iconPath = './assets/icons' + (namespace ? '/' + namespace : '') + '/' + name + '.svg';
        return this.domSanitizer.bypassSecurityTrustResourceUrl(iconPath);
      },
    );

    registerLocaleData(localeJa, 'ja-JP');
  }
}
